import { render, staticRenderFns } from "./clipboard.html?vue&type=template&id=10021eb9&scoped=true&external"
import script from "./clipboard.js?vue&type=script&lang=js&external"
export * from "./clipboard.js?vue&type=script&lang=js&external"
import style0 from "./clipboard.scss?vue&type=style&index=0&id=10021eb9&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10021eb9",
  null
  
)

export default component.exports